export const LOADER_CAMPAIGNS             =    'LOADER_CAMPAIGNS';
export const GET_CAMPAIGNS                =    'GET_CAMPAIGNS';
export const CAMPAIGNS_FAIL               =    'CAMPAIGNS_FAIL';
export const SAVE_LOADER_CAMPAIGNS        =    'SAVE_LOADER_CAMPAIGNS';
export const FORM_CAMPAIGNS_FAIL          =    'FORM_CAMPAIGNS_FAIL';
export const LOADER_TRAININGS_CALENDAR    =    'LOADER_TRAININGS_CALENDAR';
export const GET_TRAININGS_CALENDAR       =    'GET_TRAININGS_CALENDAR';
export const TRAININGS_CALENDAR_FAIL      =    'TRAININGS_CALENDAR_FAIL';
export const LOADER_TRAININGS_EMPLOYEES_CALENDAR = 'LOADER_TRAININGS_EMPLOYEES_CALENDAR';
export const GET_TRAININGS_EMPLOYEES_CALENDAR = 'GET_TRAININGS_EMPLOYEES_CALENDAR';
export const TRAININGS_EMPLOYEES_CALENDAR_FAIL = 'TRAININGS_EMPLOYEES_CALENDAR_FAIL';